import React from 'react';

import { Trans, useTranslation } from '@lyearn/i18n';
import { AlertDialog } from '@lyearn/molecules';
import { Typography } from '@lyearn/ui';

type Props = {
  open: boolean;
  onClick: () => void;
  onClose: () => void;
  name?: string;
  progress?: number;
};

const SyncProgressAlert = (props: Props) => {
  const { open, onClick, onClose, name = '', progress = 0 } = props;
  const { t } = useTranslation(['ExternalContent']);
  return (
    <AlertDialog
      header={{
        title: t('Journey:SyncProgressTitle'),
        description: (
          <Trans
            components={{
              strong: <Typography className="text-text-secondary" variant="label-02" />,
            }}
            i18nKey="Journey:SyncProgressHeaderDescription"
            values={{ name, progress }}
          />
        ),
      }}
      open={open}
      primaryAction={{ label: t('ExternalContent:Buttons.SyncProgress'), onClick }}
      onClose={onClose}
    />
  );
};

export default SyncProgressAlert;
